import * as React from "react";
import { Context } from "./_context";
export const ShoppingBagIcon = ({ size = 24, variant = "inherit", ...rest }) => {
  const { variants } = React.useContext(Context);
  const color = variants[variant] || "#F0F";
  const props = { "aria-hidden": true, style: { color }, ...rest };
  const iconset = {};
  iconset[24] = /* @__PURE__ */ React.createElement("svg", { width: "1.5rem", height: "1.5rem", fill: "none", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M13.654 2.004A3 3 0 0 1 16.5 5v1H22a1 1 0 0 1 .982 1.188l-2.345 12.19A2 2 0 0 1 18.674 21H5.326a2 2 0 0 1-1.964-1.622L1.017 7.188A1 1 0 0 1 2 6h5.5V5a3 3 0 0 1 3-3h3l.154.004ZM5.326 19h13.348l2.115-11H3.21l2.115 11ZM10.5 4a1 1 0 0 0-1 1v1h5V5a1 1 0 0 0-.898-.995L13.5 4h-3Z", fill: "currentColor" }));
  return iconset[size];
};
ShoppingBagIcon.iconId = "cAHbWH";
